export default "__VITE_ASSET__0ec0505f__"